import React from 'react';

const PageHeading = (props) => {
    return (
        <div className="page-heading">
            <div className="page-heading__inner">
                <h2>{props.title}</h2>
            </div>
        </div>
    );
};

export default PageHeading;
